var _circle, _path, _path2, _circle2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgParentChildDetailsProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#E8E8E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67 71.0001H62.9088C62.9088 63.9418 57.1197 58.2015 49.999 58.2015C42.8782 58.2015 37.0912 63.9439 37.0912 71.0001H33C33 61.6323 40.6281 54.0176 50.001 54.0176C59.3719 54.0176 67 61.6323 67 71.0001Z",
    fill: "#AEB0B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0014 51.9487C43.8176 51.9487 38.7833 46.7983 38.7833 40.4744C38.7813 34.1483 43.8155 29 50.0014 29C56.1894 29 61.2236 34.1462 61.2236 40.4744C61.2236 46.8025 56.1894 51.9487 50.0014 51.9487ZM50.0014 33.1839C46.0698 33.1839 42.8725 36.4536 42.8725 40.4744C42.8725 44.4951 46.0698 47.7648 50.0014 47.7648C53.9351 47.7648 57.1324 44.4951 57.1324 40.4744C57.1324 36.4536 53.931 33.1839 50.0014 33.1839Z",
    fill: "#AEB0B5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 88,
    r: 12,
    fill: "#455674"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0031 83.001C87.6717 83.001 87.4031 83.2515 87.4031 83.5606V92.4403C87.4031 92.7494 87.6717 92.9999 88.0031 92.9999C88.3345 92.9999 88.6031 92.7494 88.6031 92.4403V83.5606C88.6031 83.2515 88.3345 83.001 88.0031 83.001Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8057 86.6973L88.418 83.183C88.1827 82.939 87.8176 82.939 87.5823 83.183L84.1945 86.6973C83.9474 86.9537 83.9339 87.3841 84.1647 87.6587C84.2851 87.8022 84.4486 87.8747 84.6122 87.8747C84.762 87.8747 84.912 87.8142 85.03 87.6918L88 84.6107L90.97 87.6918C91.2175 87.9482 91.6046 87.9332 91.8352 87.6587C92.0659 87.3841 92.0528 86.9537 91.8057 86.6973Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParentChildDetailsProfileIcon);
export default __webpack_public_path__ + "static/media/parentChildDetailsProfileIcon.e2d26639d96e8601f0552b4b29e9e15f.svg";
export { ForwardRef as ReactComponent };